/**
 * PeriodSelector
 *
 * 주/월/년 선택 탭 + 이전/다음 네비게이션
 */

import type { PeriodType, Period } from '../../types/Statistics'

interface PeriodSelectorProps {
  period: Period
  periodType: PeriodType
  onChangePeriodType: (type: PeriodType) => void
  onPrevious: () => void
  onNext: () => void
  onToday: () => void
}

export function PeriodSelector({
  period,
  periodType,
  onChangePeriodType,
  onPrevious,
  onNext,
  onToday
}: PeriodSelectorProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 mb-4">
      {/* 타입 선택 탭 */}
      <div className="flex justify-center gap-2 mb-3">
        <button
          onClick={() => onChangePeriodType('week')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            periodType === 'week'
              ? 'bg-primary-600 text-white'
              : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200'
          }`}
        >
          주간
        </button>
        <button
          onClick={() => onChangePeriodType('month')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            periodType === 'month'
              ? 'bg-primary-600 text-white'
              : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200'
          }`}
        >
          월간
        </button>
        <button
          onClick={() => onChangePeriodType('year')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            periodType === 'year'
              ? 'bg-primary-600 text-white'
              : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200'
          }`}
        >
          연간
        </button>
      </div>

      {/* 기간 네비게이션 */}
      <div className="flex items-center justify-between">
        <button
          onClick={onPrevious}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          ◀
        </button>

        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {period.label}
          </span>
          <button
            onClick={onToday}
            className="px-2 py-1 text-xs bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
          >
            오늘
          </button>
        </div>

        <button
          onClick={onNext}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          ▶
        </button>
      </div>
    </div>
  )
}
